<template>
<!-- <v-select
  v-model="method"
  :items="methods"
  :hint='hint'
  :label="label" >
</v-select> -->
<div>
  <v-subheader class='overline pa-0' v-text='label' />
  <v-chip
    v-for='m in methods' :key='m.value'
    :small='small'
    @click='setMethod(m)' >
    <v-icon v-if='method === m.value' small left >check</v-icon>
    {{ m.text }}
  </v-chip>
  <div class='caption' v-text='hint' />
</div>
</template>
<script>
export default {
  name: 'PaymentMethodPicker',
  props: {
    value: { type: String },
    label: { type: String, default: 'Payment method' },
    hint: { type: String, default: 'How did the client pay?' },
    small: { type: Boolean, default: false }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.method = this.value }
      }
    },
    method () {
      this.$emit('input', this.method)
    }
  },
  methods: {
    setMethod (method) {
      this.method = method.value
    }
  },
  data () {
    return {
      method: '',
      methods: [
        {
          value: 'eft',
          text: 'EFT'
        },
        {
          value: 'cash',
          text: 'Cash'
        },
        {
          value: 'snapscan',
          text: 'SnapScan'
        },
        {
          value: 'credit_card',
          text: 'Creditcard'
        },
        {
          value: 'medicalaid',
          text: 'Medical Aid'
        },
        {
          value: 'gift',
          text: 'Gift'
        },
        {
          value: 'voucher',
          text: 'Voucher'
        },
        {
          value: 'other',
          text: 'Other'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentMethodPicker.vue?34caa5ee